import ecoSystemImg from "../../assets/images/dashboard/eco-profile.png";
import { useState } from "react";
import { useCookies } from "react-cookie";
import logoutImg from "../../assets/images/dashboard/back.png";
import LoginUser from "../../assets/images/dashboard/propic.png";
import "./Header.css";
import { Dialog } from "primereact/dialog";
import SffLanguage from "../../components/common/Languages/SffLanguage";
import logOutpopup from "../../assets/images/logout-pop-up.svg";
import { Dropdown } from "primereact/dropdown";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../states/store";
import { onCountrySelect } from "../../states/slice/loginSlice";
import { useEffect } from "react";

const Header = () => {
  const [showPopUp, setShowPopUp] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies([
    "codeVerifier",
    "refreshToken",
    "accessToken",
    "userId",
    "expiry",
    "tokenType",
    "userName",
    "token",
  ]);
  const action = useDispatch();
  const { t } = SffLanguage();
  const fullPath = window.location.pathname;
  const pathSegments = fullPath.split("/").filter(segment => segment !== "");
  const lastPart = pathSegments[pathSegments.length - 1];

  const { countriesDropDown, selectedCounty } = useSelector(
    (state: RootState) => state.login
  );
  const reduxStateLogin = useSelector(
    (state: RootState) => state.login
  );
  console.log("Last part of the path:", lastPart);
  const [selectedCountry, setSelectedCountry] = useState(null);
  useEffect(() => {
    console.log(sessionStorage.getItem("countryId"));
    if (sessionStorage.getItem("countryId") && sessionStorage.getItem("countryId") != "null" && sessionStorage.getItem("countryId") != "undefined") {
      let currentSelectedCountryId = sessionStorage.getItem("countryId") || "";
      let countryObj = countriesDropDown?.find((country: any) => country.countryId.toString() === currentSelectedCountryId.toString());
      setSelectedCountry(countryObj?countryObj:countriesDropDown?.[0]);
    if(!countryObj){
      sessionStorage.setItem("countryId", countriesDropDown?.[0]?.countryId);
    }
    } else {
      setSelectedCountry(reduxStateLogin.selectedCounty);
      sessionStorage.setItem("countryId", reduxStateLogin.selectedCounty.countryId);
    }
  }, [reduxStateLogin, countriesDropDown]);
  const logOutUser = () => {
    sessionStorage.clear();
    localStorage.clear();
    removeCookie("codeVerifier", undefined);
    removeCookie("refreshToken", undefined);
    removeCookie("accessToken", undefined);
    removeCookie("userId", undefined);
    removeCookie("expiry", undefined);
    removeCookie("tokenType", undefined);
    removeCookie("token", undefined);
    window.location.assign("/login");
  };

  const onChangeHeaderCountry = (e: any) => {
    action(onCountrySelect(e.value));
  };

  return (
    <>
      <header className="top_header">
        <div>
          <img
            src={ecoSystemImg}
            alt="Eco System Logo"
            className="header-roud-img"
          />
          <div style={{ fontSize: "18px" }}>FH Ecosystem Platform</div>
        </div>

        <div>
          <div className="nav-item>">
            {(!lastPart || (lastPart && lastPart !== "login")) && <Dropdown
              options={countriesDropDown || []}
              optionLabel="countryName"
              value={selectedCountry}
              placeholder="Select Country"
              className="w-full country_class"
              id="country_class"
              onChange={(e) => onChangeHeaderCountry(e)}
              filter
              resetFilterOnHide={true}
            />}
          </div>
          <img
            src={LoginUser}
            alt={cookies.userName}
            className="header-roud-img"
          />
          <span style={{ fontSize: "16px" }}>{cookies.userName}</span>
          <button className="logout-btn" onClick={() => setShowPopUp(true)}>
            <img src={logoutImg} alt="Logout" />
          </button>
        </div>
      </header>
      <Dialog
        visible={showPopUp}
        style={{ width: "40vw" }}
        breakpoints={{ "1000px": "70vw", "500px": "90vw" }}
        onHide={() => {
          setShowPopUp(false);
        }}
        closable={true}
      >
        <img src={logOutpopup} className="dialoge-image" alt="Loading" />
        <div className="text-center mb-3 mt-3">
          {t("WBA_GEN_GENE_BT_00056_AreWanAppl")}
        </div>
        <div className="flex justify-content-center gap-3 primepopup">
          <button className="logout-yes" onClick={logOutUser} autoFocus>
            {t("WBA_GEN_GENE_BT_00033_Yes")}
          </button>
          <button className="logout-no" onClick={() => setShowPopUp(false)}>
            {t("WBA_GEN_GENE_BT_00034_No")}
          </button>
        </div>
      </Dialog>
    </>
  );
};

export default Header;
